import { supabase } from "~/integrations/supabase/client";

// New parallel inventory module (inv_* schema). Reads live balances from the
// single source of truth: inv_quants, projected by the get_inv_stock RPC.
export type InvSourceKind = "finished_good" | "raw_material" | "oil";

export interface InvStockRow {
  product_id: string;
  source_kind: InvSourceKind;
  code: string | null;
  name: string;
  stock_uom: string;
  location_id: string;
  location_code: string;
  location_name: string;
  quantity: number;
  reserved_quantity: number;
  available: number;
  value: number | null;
}

export const inventoryStockService = {
  // get_inv_stock is not in the generated types yet (new schema) → cast as never.
  async getStock(search?: string): Promise<InvStockRow[]> {
    const trimmed = search?.trim();
    const { data, error } = await supabase.rpc("get_inv_stock" as never, {
      p_search: trimmed ? trimmed : null,
    } as never);
    if (error) throw error;
    return (data ?? []) as unknown as InvStockRow[];
  },
};
